import script from "./FundingSummaryView.vue?vue&type=script&setup=true&lang=js"
export * from "./FundingSummaryView.vue?vue&type=script&setup=true&lang=js"

import "./FundingSummaryView.vue?vue&type=style&index=0&id=4190dfde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4190dfde"]])

export default __exports__